export default __webpack_public_path__ + "static/image2-efc90a4c57ed346db1d28ba4513777a4.png";